/**
 * auto-captions-gigaam.js — русская дорожка распознавания для /auto-captions.
 *
 * ЗАЧЕМ. У этого тула 84% прогонов на русском (2609 против 391 английского за
 * 30 дней), а браузерный дефолт whisper `base` ошибается в 29.9% слов. GigaAM v3
 * на том же корпусе ошибается в 6.3% — втрое точнее.
 *
 * ЧЕГО ЖДАТЬ ПО СКОРОСТИ (замерено 2026-08-13 боевым воркером, не обещано):
 * десктоп ~5.5× реального времени, реальный Android-Chrome (4 ядра, 3.85 ГБ)
 * ~1.0×. То есть на телефоне это НЕ быстрее нынешнего whisper `base`
 * (0.5–1.25×), а вровень — выигрыш только в точности. Так и надо говорить.
 *
 * ⚠️ Вердикт «браузерный лейн отгружать нельзя» (BENCHMARK-browser-lane-2026-08-09)
 * переоткрыт: клин воркера не воспроизвёлся ни разу за 28 прогонов на двух
 * стендах. Но на неизвестном устройстве он всё ещё возможен, поэтому здесь есть
 * СТОРОЖ: нет прогресса N секунд → воркер убивается, ошибка типизируется, и
 * пайплайн откатывается на whisper. Устройство, где эта модель не идёт, получает
 * сегодняшнее поведение, а не зависшую страницу.
 *
 * ⚠️⚠️ БУФЕР НЕ ПЕРЕДАЁТСЯ (transfer), а КОПИРУЕТСЯ. runWhisper отдаёт
 * `pcmF32.buffer` в списке transfer, то есть ОТСОЕДИНЯЕТ его. Сделай так же
 * здесь — и после отказа GigaAM откат на whisper получил бы пустой буфер, то
 * есть страховка ломала бы ровно тот случай, ради которого заведена.
 */
(function () {
    'use strict';

    var CACHE_NAME = 'gigaam-model-v3';   // тот же ключ, что в gigaam-worker.js
    // Размер приходит из блейда ($acGigaamMb) — там же он подставляется в подпись
    // опции и в текст согласия. Одно число на все три места: разойдись оно, и
    // разойдётся ровно там, где мы обещаем человеку объём скачивания.
    var SIZE_MB = (typeof window.__gigaamMb === 'number' && window.__gigaamMb > 0) ? window.__gigaamMb
                : (typeof window.__acGigaamMb === 'number' && window.__acGigaamMb > 0) ? window.__acGigaamMb : 215;
    // Сторож: тишина дольше — считаем клином. Переопределяется так же, как у
    // whisper (window.__AC_INFERENCE_STALL_MS), чтобы тест мог проверить САМО
    // срабатывание, а не ждать три минуты.
    function stallMs() {
        var v = window.__AC_GIGAAM_STALL_MS;
        return (typeof v === 'number' && v > 0) ? v : 180000;
    }

    /* Сторож считает ВИДИМОЕ время (timbrica-core.js __visibleTimeout). Свёрнутую
       вкладку Android замораживает вместе с воркером, и стенной таймер после
       возврата срабатывал сразу: исправный прогон объявлялся «клином» и шёл
       заново на whisper (обращение 22.09.2026). Возвращает функцию отмены. */
    function visibleTimeout(fn, ms) {
        if (typeof window.__visibleTimeout === 'function') return window.__visibleTimeout(fn, ms);
        var h = setTimeout(fn, ms);
        return function () { clearTimeout(h); };
    }

    /* ── «На этом устройстве модель не пошла» — помнится 30 дней ────────────
       Модель тяжёлая: сессия и прогон 113 с речи — ~1.1 ГБ к процессу браузера
       (замер 26.09.2026, от уровня оптимизации графа не зависит). Где её не
       тянут, отказ повторялся бы на каждом прогоне: RU 30 д, iOS — 10 удач
       против 20 откатов, и сессии с GigaAM дошли до текста в 19 из 71 против
       117 из 231 у одного whisper. Поэтому НАСТОЯЩИЙ отказ модели (память,
       wasm, сессия) — вердикт устройству: дверь здесь больше не предлагается и
       скачанная модель не включается сама. Сеть вердиктом не бывает — модель
       бы заработала, просто сейчас не скачалась (урок #6850: сетевой отказ,
       ведущий себя как приговор, молча уносит точность). Приговор — после
       ДВУХ отказов, как у whisper-gpu-policy.js: на Android память бывает
       занята соседними вкладками, и один сбой не должен на месяц отнимать
       точную модель. Удачный прогон обнуляет счёт. */
    var FAIL_KEY = 'gigaam_device_failed_v1';
    var FAIL_TTL_MS = 30 * 24 * 3600 * 1000;
    var FAIL_STRIKES = 2;
    function readFails() {
        try {
            var v = JSON.parse(localStorage.getItem(FAIL_KEY) || 'null');
            if (!v || !(v.at > 0)) return null;
            if (Date.now() - v.at > FAIL_TTL_MS) { localStorage.removeItem(FAIL_KEY); return null; }
            return v;
        } catch (e) { return null; }
    }
    function failedHere() {
        var v = readFails();
        return !!(v && (v.strikes | 0) >= FAIL_STRIKES);
    }
    /* Страйк — только отказ, который говорит об УСТРОЙСТВЕ: не хватило памяти
       или wasm аварийно остановился. Сеть, обрыв загрузки, повреждённый файл
       модели (воркер его уже выкинул из кэша — «model file corrupt») —
       повод скачать заново, а не отнять модель. Список узкий намеренно:
       незнакомая ошибка не должна становиться приговором. */
    function isDeviceFailure(msg) {
        msg = String(msg || '');
        if (/model file corrupt|model download|HTTP \d{3}|Failed to fetch|NetworkError|Load failed|net::ERR_/i.test(msg)) return false;
        return /out of memory|RangeError|Aborted\(|abort\(|allocation|allocate|memory access out of bounds|bad_alloc|OOM/i.test(msg);
    }
    function noteOutcome(ok, err) {
        try {
            if (ok) { localStorage.removeItem(FAIL_KEY); return false; }
            var type = err && err.errorType;
            var msg = String((err && err.message) || '');
            if ((type === 'gigaam_failed' || type === 'gigaam_worker_error') && isDeviceFailure(msg)) {
                var prev = readFails();
                var strikes = ((prev && prev.strikes) | 0) + 1;
                localStorage.setItem(FAIL_KEY, JSON.stringify({ at: Date.now(), strikes: strikes, why: msg.slice(0, 80) }));
                return strikes >= FAIL_STRIKES;
            }
        } catch (e) {}
        return false;
    }

    function lc(v) { return String(v == null ? '' : v).toLowerCase(); }

    /** Модель русская и отказывает на чужом языке МОЛЧА (английский приходит
     *  уверенной фонетической кашей), поэтому гейт строгий: только явный `ru`.
     *  `auto` не годится — до декодирования язык неизвестен. */
    function eligible(lang) {
        return lc(lang) === 'ru';
    }

    /** Уже скачана? Тогда спрашивать разрешение второй раз — шум.
     *  Cache API живёт только в защищённом контексте; в незащищённом честно
     *  отвечаем «нет», и пользователь увидит вопрос про объём.
     *
     *  Скачанной считается САМА МОДЕЛЬ (.onnx), а не «хоть что-то в кэше»:
     *  воркер кладёт туда сначала крошечный словарь токенов, и после
     *  сорвавшейся загрузки модели (сеть, обрыв, битый файл — его воркер
     *  выкидывает) словарь остаётся один. Прежнее `keys().length > 0`
     *  объявляло такую модель скачанной: дверь не показывалась, селект
     *  молча переключался на GigaAM, и следующий запуск тянул 215 МБ без
     *  вопроса — ровно тем, у кого первая загрузка и сорвалась, то есть на
     *  плохой сети (26.09.2026, стенд auto-captions-gigaam-device-verdict,
     *  G2b). Тем же правилом кэш читают karaoke-autosync и lyrics-ai-timing. */
    function isCached() {
        try {
            if (typeof caches === 'undefined') return Promise.resolve(false);
            return caches.open(CACHE_NAME)
                .then(function (c) { return c.keys(); })
                .then(function (k) {
                    for (var i = 0; i < k.length; i++) if (k[i] && /gigaam_v3_e2e_ctc_int8\.onnx/.test(k[i].url || '')) return true;
                    return false;
                })
                .catch(function () { return false; });
        } catch (e) { return Promise.resolve(false); }
    }

    /** Пользователь прямо попросил экономить трафик — не предлагаем 215 МБ сами. */
    function saveData() {
        try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; }
    }

    function workerUrl() {
        var base = window.__gigaamWorkerUrl
               || (window.__acWorkerBase && window.__acWorkerBase.gigaam)
               || '/js/gigaam-worker.js';
        var loc = (window.__LOCALE ? String(window.__LOCALE) : 'en').toLowerCase();
        var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'locale=' + encodeURIComponent(loc);
        /* Which ORT build the worker loads is the owner's answer, carried on the
           worker's URL (see gigaam-worker.js). `simdOnly`: the model was never
           measured on a CPU without SIMD — that CPU keeps its present answer. */
        var B = window.__ortBuild;
        return (B && B.workerUrl) ? B.workerUrl(url, { simdOnly: true }) : url;
    }

    /**
     * Отрезки речи в PACKED-домене. Пайплайн уже прогнал VAD и склеил речь без
     * пауз, положив карту в state.vadOffsetMap — берём её границы, они и есть
     * естественные швы. Без VAD отдаём null: воркер сам режет по MAX_DECODE_SEC
     * (у модели потолок — ОДНА РЕПЛИКА, дальше слова рассыпаются, поэтому резать
     * обязательно).
     */
    function segmentsFromOffsetMap(map, mergeSec) {
        if (!map || !map.length) return null;
        // ⚠️ Карта пайплайна называет поля newStartSec/newEndSec (packPcmBySegments).
        // До 2026-09-09 здесь читались newStart/newEnd — которых нет — и функция
        // ВСЕГДА отдавала null, так что швы VAD воркер не видел и резал упакованную
        // речь по глухим 20-секундным окнам (замер 09.09: на тихой записи FLEURS
        // это стоило половины слов вместе с самим VAD — см. пайплайн, «leveling»).
        var raw = [];
        for (var i = 0; i < map.length; i++) {
            var s = map[i];
            var a = isFinite(s.newStartSec) ? s.newStartSec : s.newStart;
            var b = isFinite(s.newEndSec) ? s.newEndSec : s.newEnd;
            if (isFinite(a) && isFinite(b) && b > a) raw.push({ start: a, end: b });
        }
        if (!raw.length) return null;
        // Швы — естественные, но КАЖДЫЙ вызов модели стоит накладных расходов, а
        // фрагменты по 0.8 с их только множат. Соседние отрезки склеиваются в окна
        // до MERGE_SEC (они и так лежат встык в упакованном буфере); длиннее
        // MAX_DECODE_SEC воркер режет сам.
        var MERGE_SEC = (mergeSec > 0) ? mergeSec : 15;   // GigaAM — 15 с; whisper зовёт с 28 (окно модели 30 с)
        var out = [raw[0]];
        for (var k = 1; k < raw.length; k++) {
            var last = out[out.length - 1];
            if (raw[k].end - last.start <= MERGE_SEC) last.end = raw[k].end;
            else out.push({ start: raw[k].start, end: raw[k].end });
        }
        return out;
    }

    /**
     * Запустить распознавание. Возвращает ТУ ЖЕ форму, что runWhisper:
     * { text, chunks: [{ text, timestamp: [start, end], ls? }], wordLevel, detectedLang } — слово на кусок, когда воркер дал слова
     * — чтобы всё, что ниже по пайплайну (разбивка, тайминги, экспорт), не знало,
     * каким движком получен текст.
     *
     * @param {Float32Array} pcm  16 кГц моно; НЕ отсоединяется (см. шапку)
     */
    function run(pcm, opts, onEvt) {
        return runOnce(pcm, opts, onEvt, false).catch(function (e) {
            /* «no available backend found … RangeError: Out of memory» at start is
               not this device running out of memory: the browser could not RESERVE
               the shared 4 GiB the current ORT build imports (WebKit before 18).
               The owner has marked the browser and now answers ORT 1.18, which
               needs no reservation — once more in a fresh worker (the model is in
               the cache), after a pause: an immediate retry meets the same address
               space. Until 2026-10-11 this failure counted as a strike against the
               DEVICE, and two of them took the model away for 30 days. */
            if (!(e && e.ortNoShare)) throw e;
            return new Promise(function (r) { setTimeout(r, 1000); })
                .then(function () { return runOnce(pcm, opts, onEvt, true); });
        });
    }

    function cancelledError() {
        var e = new Error('cancelled');
        e.errorType = 'cancelled';
        e.expected = true;
        return e;
    }

    function runOnce(pcm, opts, onEvt, isRetry) {
        opts = opts || {};
        return new Promise(function (resolve, reject) {
            var settled = false, timer = null, w = null, url = workerUrl();
            /* Отмена гасит воркер — и не записывается устройству в отказы. До
               29.10.2026 отменить GigaAM было нечем: воркер жил внутри этого
               промиса, и «Отмена» /auto-captions гасила whisper, VAD и перевод,
               а распознавание 92-минутного видео шло дальше ещё час, отнимая
               процессор у следующего прогона (чат 730). */
            var signal = opts.signal || null;
            if (signal && signal.aborted) { reject(cancelledError()); return; }
            function onAbort() {
                if (settled) return;
                settled = true;
                if (timer) { timer(); timer = null; }
                try { if (w) w.terminate(); } catch (e) {}
                reject(cancelledError());
            }
            if (signal) signal.addEventListener('abort', onAbort, { once: true });

            function settle(isErr, val) {
                if (settled) return;
                settled = true;
                if (signal) signal.removeEventListener('abort', onAbort);
                if (timer) { timer(); timer = null; }
                if (isErr) { try { if (w) w.terminate(); } catch (e) {} }
                var B = window.__ortBuild;
                if (isErr && val && !isRetry && B && B.initFailed
                    && B.initFailed(val, { legacy: /[?&]ortb=/.test(url) ? 'legacy' : '', from: 'gigaam' })) {
                    val.ortNoShare = true;
                } else if (isErr && val) val.learned = noteOutcome(false, val);
                else if (!isErr) noteOutcome(true);
                (isErr ? reject : resolve)(val);
            }
            function arm() {
                if (timer) timer();
                var ms = stallMs();
                timer = visibleTimeout(function () {
                    var e = new Error('gigaam: no progress in ' + Math.round(ms / 1000) + 's');
                    e.errorType = 'gigaam_stalled';
                    e.expected = true;
                    settle(true, e);
                }, ms);
            }

            try {
                w = new Worker(url);
                arm();

                w.onmessage = function (ev) {
                    var m = ev.data || {};
                    if (onEvt) { try { onEvt(m); } catch (e) {} }
                    // Любой признак жизни двигает сторож: скачивание модели на
                    // медленной сети идёт минутами и прогрессом НЕ является в
                    // смысле распознавания, но и клином не является тоже.
                    if (m.type === 'progress' || m.type === 'ready') arm();
                    if (m.type === 'error') {
                        var er = new Error(m.error || 'gigaam error');
                        er.errorType = 'gigaam_failed';
                        er.expected = true;
                        return settle(true, er);
                    }
                    if (m.type === 'ready') {
                        // Копия, а не transfer — оригинал нужен целым для отката.
                        var copy = new Float32Array(pcm.length);
                        copy.set(pcm);
                        w.postMessage({ type: 'transcribe', pcm: copy, segments: opts.segments || null });
                        return;
                    }
                    if (m.type === 'result') {
                        var segs = m.segments || [];
                        /* Слова — с тем временем, когда модель их написала (куски CTC),
                           а не доля отрезка по числу букв: субтитры «по одному слову»
                           (выгрузка для монтажа, чат 640, 20.10.2026) иначе вспыхивают
                           не там, где слово сказано. Отрезок без слов (старый воркер в
                           кэше посетителя) — прежняя форма для всего ответа. */
                        var wordChunks = [], allWords = segs.length > 0;
                        for (var j = 0; j < segs.length && allWords; j++) {
                            var ws = segs[j].words;
                            if (!ws || !ws.length) { allWords = !String(segs[j].text || '').trim(); continue; }
                            for (var k = 0; k < ws.length; k++) {
                                var tw = String(ws[k].text || '').trim();
                                if (!tw) continue;
                                var c = { text: tw, timestamp: [ws[k].start, ws[k].end] };
                                if (ws[k].ls) c.ls = 1;
                                wordChunks.push(c);
                            }
                        }
                        var chunks = [];
                        if (!allWords || !wordChunks.length) {
                            for (var i = 0; i < segs.length; i++) {
                                var t = String(segs[i].text || '').trim();
                                if (t) chunks.push({ text: t, timestamp: [segs[i].start || 0, segs[i].end || 0] });
                            }
                        }
                        try { w.terminate(); } catch (e) {}
                        settle(false, {
                            text: String(m.text || '').trim(),
                            chunks: chunks.length ? chunks : wordChunks,
                            wordLevel: !chunks.length,
                            detectedLang: 'ru',
                            engine: 'gigaam',
                        });
                        return;
                    }
                };
                w.onerror = function (e) {
                    var er = new Error((e && e.message) || 'gigaam worker error');
                    er.errorType = 'gigaam_worker_error';
                    er.expected = true;
                    settle(true, er);
                };

                w.postMessage({ type: 'init', locale: 'ru' });
            } catch (err) {
                settle(true, err);
            }
        });
    }

    /* Canonical name. This module started inside /auto-captions and is now
       the shared Russian on-device lane (/speech-to-text uses it through the
       whisper-model-picker's consent door). `ACGigaam` stays as an alias so
       that tool needs no change — one implementation, two names, rather than
       two implementations. */
    window.GigaamAsr = {
        CACHE_NAME: CACHE_NAME,
        SIZE_MB: SIZE_MB,
        eligible: eligible,
        isCached: isCached,
        saveData: saveData,
        failedHere: failedHere,
        // For tests/js — the classifier has to be holdable from outside.
        _isDeviceFailure: isDeviceFailure,
        _noteOutcome: noteOutcome,
        segmentsFromOffsetMap: segmentsFromOffsetMap,
        run: run,
    };
    window.ACGigaam = window.GigaamAsr;
})();
